/**
 * Available roles for currently known modules
 */
export enum RoleType {
	// DCV => datachain viewer AKA datachain marketplace
	DCV_MEMBER = 'DCV_MEMBER',
	DCV_ADMIN = 'DCV_ADMIN',
	DCV_ADMIN_LOG = 'DCV_ADMIN_LOG',

	// DCC => datachain console
	DCC_MEMBER = 'DCC_MEMBER',
	DCC_ORGANIZATION_ADMIN = 'DCC_ORGANIZATION_ADMIN',
	DCC_ADMIN = 'DCC_ADMIN',
	DCC_ADMIN_LOG = 'DCC_ADMIN_LOG',

	// DC  => datachain core
	DC_MEMBER = 'DC_MEMBER',
	DC_CONSO = 'DC_CONSO',
	DC_PROJECT = 'DC_PROJECT',
	DC_ADMIN = 'DC_ADMIN',
	DC_LOG_ADMIN = 'DC_LOG_ADMIN',
}

export enum ProductInstanceTypeModel {
	DcCore = 'DC_CORE',
	DcMaestro = 'DC_MAESTRO',
	DcMarketplace = 'DC_MARKETPLACE',
	Dccode = 'DC_CODE',
	DcConsole = 'DC_CONSOLE',
}
